"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _popmotion = require("popmotion");
var _react = require("react");
var useAnimation = function useAnimation() {
  var heightTransition = (0, _react.useCallback)(function (params) {
    var element = params.element,
      from = params.from,
      to = params.to,
      onComplete = params.onComplete;
    (0, _popmotion.animate)({
      from: from,
      to: to,
      duration: 300,
      onComplete: onComplete,
      onUpdate: function onUpdate(latest) {
        if (element) {
          element.style.height = "".concat((0, _popmotion.toDecimal)(latest), "px");
        }
      }
    });
  }, []);
  return {
    heightTransition: heightTransition
  };
};
var _default = useAnimation;
exports.default = _default;